import React from 'react';
import OrgulloUPCarousel from './Slider/orgulloUp';
import axios from 'axios';
import BeneficiosUp from "./Content/beneficios";
import {Col, Row} from 'react-bootstrap';

interface VAlumno {
    Nombre: string;
    Carrera: string;
    FechaEgreso: string;
    url_foto: string;
}

interface OrgulloSlide {
    nombre: string;
    carrera: string;
    anio: string;
    nombreEmpresa: string;
    descripcion: string;
    plantilla: string; // Imagen de fondo
    datosAlumno: VAlumno;
}

interface beneficioUp {
    id: number;
    titulo: string;
    descripcion: string;
    url: string;
    vigencia: Date;
    logo_empresa?: string;
    status: string;
    nombre_empresa: string;
    imagen: string;
    created_at: Date;
    contacto: string;
}

const API_URL = process.env.REACT_APP_API_URL;

const OrgulloUPWrapper: React.FC = () => {
    const [slides, setSlides] = React.useState<OrgulloSlide[]>([]);
    const [beneficios, setBeneficios] = React.useState<beneficioUp[]>([]);

    const getInfo = async () => {
        try {
            const response = await axios.get(`${API_URL}/enlaces/getOrgullo`)
            const items = response.data;
            setSlides(items);

            const rBeneficios = await axios.get(`${API_URL}/enlaces/getBeneficios`)
            const beneficios = rBeneficios.data;
            setBeneficios(beneficios);

        } catch (error) {
            console.log('Error: ', error)
        }
    }

    React.useEffect(() => {
        getInfo();
    }, []);

    return (
        <Row>
            <Col md={12} sm={12} xs={12} xl={12} style={{padding: 0}}>
                <OrgulloUPCarousel slides={slides}/>
            </Col>
            <Col md={12} sm={12} xs={12} xl={12} style={{height: '29vh'}}>
                <BeneficiosUp beneficios={beneficios} />
            </Col>
        </Row>
    )
}

export default OrgulloUPWrapper;
